<template>
    <transition name="imagecrop">
        <div>
            <div class="image-crop h-full fixed pin-x pin-y z-50 md:z-50" v-if="show">
                <div class="image-crop-bg"></div>

                <div class="image-crop-inner h-full relative px-4 overflow-y-scroll">
                    <div class="image-crop-title mx-auto py-10">
                        <h2 class="text-center text-blue">Edit Your Photo</h2>
                    </div>

                    <div class="w-full osm-croppie">
                        <vue-croppie ref="croppie"
                                     :enableOrientation="true"
                                     :boundary="{ width: 300, height: 300 }"
                                     :viewport="{ width: 250, height: 250, type: 'square'}"
                        >
                        </vue-croppie>

                        <div class="flex justify-center sm:mb-4 sm:my-0 my-10">
                            <button class="btn btn--colored__blue w-full sm:w-auto" @click="rotate(90)">
                                <i class="fal fa-undo"></i>
                            </button>

                            <button class="btn btn--colored__blue w-full sm:w-auto" @click="rotate(-90)">
                                <i class="fal fa-undo fa-flip-horizontal"></i>
                            </button>
                        </div>

                        <div class="flex justify-center sm:mb-4 sm:my-0 my-10">
                            <button class="btn btn--colored__blue w-full sm:w-auto" @click="onChange">
                                Change Image
                            </button>
                        </div>

                        <div class="flex justify-center md:pb-0 pb-8">
                            <button class="btn btn--colored__red px-6 mr-4"
                                    v-if="showDelete" @click="onDelete">
                                <i class="fas fa-trash"></i>
                            </button>

                            <button class="btn btn--colored__comet mr-2 w-full sm:w-auto" @click="onCancel">
                                <i class="fal fa-times"></i>
                                Cancel
                            </button>

                            <button class="btn btn--colored__green ml-2 w-full sm:w-auto" @click="crop">
                                <i class="fal fa-check"></i>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {

        props: {

            image: {
                type: String,
            },

            showDelete: {
                type: Boolean,
                default: true
            },

            /**
             * See http://foliotek.github.io/Croppie/
             */
            imageFormat: {
                type: String,
                default: 'png'
            },

            imageType: {
                type: String,
                default: 'blob'
            },
        },

        data() {
            return {
                show: false,
            }
        },

        methods: {
            close() {
                this.show = false
            },

            open() {
                this.show = true;
                this.$nextTick(() => {
                    this.$refs.croppie.bind({
                        url: this.image,
                        zoom: 0
                    })
                });
            },

            rotate(rotationAngle) {
                this.$refs.croppie.rotate(rotationAngle);
            },

            crop() {
                this.$refs.croppie.result({format: this.imageFormat, type: this.imageType}, (output) => {
                    this.close();
                    this.$emit('crop', output);
                });
            },

            onDelete() {
                this.$emit('delete');
            },

            onChange() {
                this.close();
                this.$emit('change')
            },

            onCancel() {
                this.close();
                this.$emit('cancel');
            },
        },
    }
</script>

<style lang="scss">
.image-crop {
    backdrop-filter: blur(10px);
}

.image-crop-bg {
    background-image: url('../assets/background.jpg');
    background-size: cover;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    opacity: 0.9;
    &:after {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.9);
    }
}

.image-crop-inner {
    z-index: 2;
}

.image-crop-title {
    transition-duration: 1s;
    transition-property: opacity;
    transition-timing-function: ease;
    transition-delay: .5s;
}

.bg-empty-image {
    cursor: pointer;
    background-color: #E9EDF5;
}

.imagecrop-enter-active,
.imagecrop-leave-active {
    transition-duration: .2s;
    transition-property: opacity;
    transition-timing-function: ease;
}

.imagecrop-enter,
.imagecrop-leave-active {
    opacity: 0;
    .image-crop-inner {
        opacity: 0;
        transform: scale(0.8)
    }
}

.osm-croppie .cr-slider {
    padding: 12px;

    &::-moz-range-thumb {
        background: #25499c;
        height: 18px;
        width: 18px;
    }

    &::-webkit-slider-thumb {
        background: #25499c;
        height: 18px;
        width: 18px;
    }

    &::-moz-range-track {
        background: #555;
        height: 3px;
    }
}

.cr-boundary {
    min-height: 300px;
    min-width: 300px;
}
</style>
